<template>
  <div class="credit-report-container">
    <van-notice-bar left-icon="volume-o" :scrollable="false" wrapable>
      请填写身份信息，提交前请确认信息准确性！
    </van-notice-bar>
    <div v-if="bizNo">
      <template v-if="!hasChecked">
        <div class="info-container">
          <van-cell-group>
            <div class="cert-photo">
              <div class="label">
                <span>身份证正面</span>
              </div>
              <div class="value">
                <van-uploader v-model="formValue.certPhotoFront" preview-size="100" :max-size="10 * 1024 * 1024"
                  :max-count="1" :before-read="onBeforeRead" :after-read="onAfterReadFront" @oversize="onOversize"
                />
              </div>
            </div>
            <div class="cert-photo">
              <div class="label">
                <span>身份证反面</span>
              </div>
              <div class="value">
                <van-uploader v-model="formValue.certPhotoBack" preview-size="100" :max-size="10 * 1024 * 1024"
                  :max-count="1" :before-read="onBeforeRead" :after-read="onAfterReadBack" @oversize="onOversize"
                />
              </div>
            </div>
            <div class="cert-photo">
              <div class="label">
                <span>自拍头像照</span>
              </div>
              <div class="value">
                <van-uploader v-model="formValue.certPhotoHold" preview-size="100" :max-size="10 * 1024 * 1024"
                  :max-count="1" :before-read="onBeforeRead" :after-read="onAfterReadHold" @oversize="onOversize"
                />
              </div>
            </div>
            <van-field v-model="formValue.name" required clearable label="真实姓名" placeholder="请填写真实姓名" :maxlength="4" />
            <van-field v-model="formValue.certId" required clearable label="身份证号" placeholder="请填写身份证号"
              :maxlength="18" />
            <van-field v-model="formValue.houseAddr" required clearable label="户籍地址" placeholder="请填写户籍地址"
              type="textarea" show-word-limit :maxlength="100" :row="3" />
            <van-field v-model="formValue.phoneNo" required clearable label="手机号码" placeholder="请填写手机号码"
              :maxlength="11" />
            <van-field v-model="formValue.vCode" required clearable label="短信验证码" placeholder="请填写短信验证码" :maxlength="6"
              class="code-field">
              <template #button>
                <van-button style="width: 110px;" size="small" type="primary" @click="onSendCode" :disabled="counting">
                  {{ counting ? `重新发送(${countDown}s)` : '发送验证码' }}
                </van-button>
              </template>
            </van-field>
          </van-cell-group>
        </div>
        <div class="button-container">
          <van-button type="warning" round block @click="onSubmit" :loading="loading" :disabled="!canSend">
            <span>提交信息</span>
          </van-button>
        </div>
      </template>
      <template v-else>
        <van-empty style="margin-top: 200px;" image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="提交信息成功，收到短信后请授权查询" />
      </template>
    </div>
    <div v-else>
      <van-empty style="margin-top: 200px;" image="https://img01.yzcdn.cn/vant/empty-image-default.png"
        description="请授权本页面获取鉴权" />
    </div>
  </div>
</template>
<script>
import { compressAccurately } from 'image-conversion'
import * as RegExp from '@/constants/regExp'
import { uploadFile } from '@/services/FileService'
import { queryCreditReport, getWithBizNo, ocrIdCard, authCustomer } from '@/services/ReportService'

export default {
  data() {
    const bizNo = this.$route.query.bizNo
    return {
      bizNo: bizNo ? decodeURIComponent(bizNo) : undefined,
      hasChecked: false,
      loading: false,
      counting: false,
      countDown: 60,
      orderInfo: {},
      formValue: {
        name: '',
        phoneNo: '',
        certId: '',
        houseAddr: '',
        certPhotoFront: [],
        certPhotoFrontUrl: '',
        certPhotoBack: [],
        certPhotoBackUrl: '',
        certPhotoHold: [],
        certPhotoHoldUrl: '',
        serialNo: '',
        vCode: ''
      }
    }
  },
  computed: {
    canSend() {
      const { name, phoneNo, certId, houseAddr, certPhotoFrontUrl, certPhotoBackUrl, certPhotoHoldUrl, vCode } = this.formValue
      return name && phoneNo && certId && houseAddr && certPhotoFrontUrl && certPhotoBackUrl && certPhotoHoldUrl && vCode
    }
  },
  mounted() {
    document.title = '身份信息'
    this.onInitBizInfo()
  },
  methods: {
    async onInitBizInfo() {
      const response = await getWithBizNo({
        bizNo: this.bizNo
      })
      this.orderInfo = response.data
      this.formValue.phoneNo = this.orderInfo.phoneNo
      if (this.orderInfo.status !== -1) {
        this.hasChecked = true
      }
    },
    onOversize() {
      this.$toast('图片文件大小不能超过10M');
    },
    onBeforeRead(file) {
      if (file.type !== 'image/jpeg') {
        this.$toast('请上传正确格式的图片')
        return false
      }
      return true
    },
    async onAfterRead(file, field) {
      file.status = 'uploading'
      file.message = '上传中...'
      compressAccurately(file.file, 256).then(res => {
        const reader = new FileReader()
        reader.readAsDataURL(res)
        reader.onload = async e => {
          const response = await uploadFile({
            base64Content: e.target.result.split(',')[1],
            fileName: file.file.name,
            callback: (progress) => {
              file.message = `${progress}%`
            }
          })
          if (response.code === 1000) {
            this.formValue[field] = response.data
            file.status = 'done'
            file.message = ''
            this.$toast('图片上传成功')
            if (field === 'certPhotoFrontUrl') {
              const ocrResponse = await ocrIdCard({
                idFaceImg: this.formValue.certPhotoFrontUrl
              })
              const ocrData = ocrResponse.data
              this.formValue.name = ocrData.name
              this.formValue.certId = ocrData.idNumber
              this.formValue.houseAddr = ocrData.address
            }
          } else {
            this.$toast('图片上传失败')
            file.status = 'failed'
            file.message = '上传失败'
          }
        }
        reader.onerror = () => {
          this.$toast('图片上传失败')
          file.status = 'failed'
          file.message = '上传失败'
        }
      })
    },
    onAfterReadFront(file) {
      this.onAfterRead(file, 'certPhotoFrontUrl')
    },
    onAfterReadBack(file) {
      this.onAfterRead(file, 'certPhotoBackUrl')
    },
    onAfterReadHold(file) {
      this.onAfterRead(file, 'certPhotoHoldUrl')
    },
    validateFormValue(type = 'submit') {
      const {
        name, certId, phoneNo, houseAddr, certPhotoFront, certPhotoBack, certPhotoHold, vCode
      } = this.formValue
      if (!RegExp.NAME_REG.test(name)) {
        this.$toast('请填写正确的真实姓名')
        return false
      }
      if (!RegExp.PHONE_REG.test(phoneNo)) {
        this.$toast('请填写正确的手机号码')
        return false
      }
      if (!RegExp.ID_CARD_REG.test(certId)) {
        this.$toast('请填写正确的身份证号')
        return false
      }
      if (!houseAddr) {
        this.$toast('请填写正确的户籍地址')
        return false
      }
      if (!certPhotoFront || !certPhotoFront.length) {
        this.$toast('请上传身份证正面')
        return false
      }
      if (!certPhotoBack || !certPhotoBack.length) {
        this.$toast('请上传身份证反面')
        return false
      }
      if (!certPhotoHold || !certPhotoHold.length) {
        this.$toast('请上传自拍头像照')
        return false
      }
      if (!vCode && type === 'submit') {
        this.$toast('请填写正确的短信验证码')
        return false
      }
      return true
    },
    async onSendCode() {
      if (!this.counting) {
        if (!this.validateFormValue('vCode')) {
          return
        }
        this.counting = true
        clearInterval(this.sendTimer)
        this.sendTimer = setInterval(() => {
          this.countDown = this.countDown - 1
          if (this.countDown === 0) {
            clearInterval(this.sendTimer)
            this.counting = false
            this.countDown = 60
          }
        }, 1000)
        const response = await authCustomer({
          name: this.formValue.name,
          phoneNo: this.formValue.phoneNo,
          certNo: `${this.formValue.certId}`.toUpperCase(),
        })
        if (response.code === 1000) {
          this.formValue.serialNo = response.data.serialNo
          this.$toast({
            message: '发送成功，请查收',
            duration: 3000
          })
        }
      }
    },
    async onSubmit() {
      if (!this.validateFormValue('submit')) {
        return
      }
      this.loading = true
      const params = {
        id: this.orderInfo.id,
        buId: this.orderInfo.buId,
        name: this.formValue.name,
        houseAdd: this.formValue.houseAddr,
        idFaceImg: this.formValue.certPhotoFrontUrl,
        idBackImg: this.formValue.certPhotoBackUrl,
        idHoldImg: this.formValue.certPhotoHoldUrl,
        certNo: `${this.formValue.certId}`.toUpperCase(),
        phoneNo: this.formValue.phoneNo,
        serialNo: this.formValue.serialNo,
        vCode: this.formValue.vCode
      }
      const response = await queryCreditReport(params)
      this.loading = false
      if (response.code === 1000) {
        this.hasChecked = true
        this.$toast('提交信息成功，正在授权查询')
      } else {
        this.$toast(response.message || '提交失败')
      }
    }
  }
}
</script>
<style lang="stylus">
  .credit-report-container {
    width: 100%;
    min-height 100%
    margin: 0 auto;
    background: #f7f8fa;
    padding-bottom 84px
    &.no-auth {
      display flex
      justify-content center
      align-items center
    }
    .info-container {
      .title {
        padding 16px
        font-size 16px
        line-height 16px
        font-weight normal
        color rgba(69, 90, 100, 0.6)
      }
      .code-field {
        padding 5px 16px
        display flex
        align-items center
      }
      .cert-photo {
        width 100%
        display flex
        padding 10px 16px
        font-size 14px
        color #646566
        position relative
        &::after {
          position: absolute;
          box-sizing: border-box;
          content: ' ';
          pointer-events: none;
          right: 0.16rem;
          bottom: 0;
          left: 0.16rem;
          border-bottom: 0.01rem solid #ebedf0;
          transform: scaleY(.5);
        }
        .label {
          width 6.2em
          margin-right 12px
          &::before {
            position: absolute;
            left: 8px;
            color: #ee0a24;
            font-size: 14px;
            content: '*';
          }
        }
      }
    }
    .button-container {
      position: fixed
      bottom 0
      left 0
      padding: 20px 10px
      width: 100%
      background: #f7f8fa;
      .van-checkbox {
        justify-content center
        margin-bottom 5px
      }
    }
  }
</style>
